import React from 'react';
import { Router, RouterProps } from 'react-router-dom';
import { History } from 'history';

type CustomHistoryRouterProps = Omit<RouterProps, 'location' | 'navigator'> & {
  history: History;
};

// Taken from: https://stackoverflow.com/a/70646548
export const CustomHistoryRouter = ({
  history,
  ...props
}: CustomHistoryRouterProps) => {
  const [state, setState] = React.useState({ location: history.location });

  React.useLayoutEffect(() => history.listen(setState), [history]);

  return <Router {...props} location={state.location} navigator={history} />;
};
